<script>

    import { toast } from 'bulma-toast'
    import { facturamaInvoicesStore, notifyStore } from '../stores'

    import FacturamaService from '../$services/facturama.service'
    import Spinner from '../$components/spinner.svelte'

    let data = {}
    let loading = false

    async function createInvoice() {

        loading = true
        const resp = await FacturamaService.createInvoice(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        facturamaInvoicesStore.append(resp.data)
        toast({message: 'Factura creada', type: 'is-success'})
        notifyStore.set('facturama_invoices_updated')
        data = {}
    }

</script>

<div class="title">Facturar</div>

<Spinner {loading} />

{#if !loading}
    <form on:submit|preventDefault={createInvoice}>
        
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">Monto a facturar</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-dollar-sign"></i></span>
                        <input bind:value={data.amount} type="text" class="input" placeholder="Monto a facturar" required>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="field">
                    <label for="" class="label">Uso del CDFI</label>
                    <div class="control">
                        <div class="select">
                            <select bind:value={data.cfdiUse} required>
                                <option value="">Uso del CDFI</option>
                                <option value="P01">Por definir</option>
                                <option value="G03">Gastos en general</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="field">
            <label for="" class="label">Método de pago</label>
            <div class="control">
                <div class="select">
                    <select bind:value={data.paymentType} required>
                        <option value="">Método de pago</option>
                        <option value="99">Por definir</option>
                        <option value="04">Tarjeta de crédito</option>
                        <option value="28">Tarjeta de débito</option>
                        <option value="01">Efectivo</option>
                        <option value="02">Cheque nominativo</option>
                        <option value="03">Transferencia electrónica de fondos</option>
                    </select>
                </div>
            </div>
        </div>
        
        <div class="items-end">
            <button class="button is-primary">
                <span class="icon"><i class="fas fa-file-invoice-dollar"></i></span>
                <span>Generar</span>
            </button>
        </div>
    </form>
{/if}